/**
 * Finds the GDISizeGuidesBlock whose CategoryId matches the product's
 * c_sizeChartWeb attribute and returns its renderable content items.
 *
 * Mirrors the resolution used by the PDP SizeChartDrawer so the quick view
 * drawer is populated with (and gated by) the same CMS content.
 *
 * Structure:
 *   optimizelyContent.item.SizeGuides[]
 *     → ContentLink.Expanded (GDISizeGuidesBlock)
 *       → CategoryId: "gar-tops-size-chart_alphabetical"
 *       → GDISizeGuidesBlockContent[]: content area items
 *
 * @param {Array} sizeGuides - The SizeGuides array from optimizely content.
 * @param {string} sizeChartId - The product's c_sizeChartWeb attribute value.
 * @returns {Array} The matched block's content items, or an empty array.
 */
export const resolveSizeGuideBlocks = (sizeGuides, sizeChartId) => {
    if (!Array.isArray(sizeGuides) || !sizeChartId) return []
    const match = sizeGuides.find(
        (entry) => entry?.ContentLink?.Expanded?.CategoryId === sizeChartId
    )
    return match?.ContentLink?.Expanded?.GDISizeGuidesBlockContent ?? []
}
